module.exports = __webpack_public_path__ + "img/icon-stock-setting2.edf73e35.png";